import { render, staticRenderFns } from "./GenericError.vue?vue&type=template&id=0b3dfed9"
import script from "./GenericError.vue?vue&type=script&lang=ts"
export * from "./GenericError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports